import { render, staticRenderFns } from "./uploadMedia.vue?vue&type=template&id=08dfafb7&"
import script from "./uploadMedia.vue?vue&type=script&lang=js&"
export * from "./uploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./uploadMedia.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports